module.exports = __webpack_public_path__ + "img/eyes.f2748c19.png";